import './Styles/Footer.css'

function Footer(){
    return(
        <div>
            <div className="footer">
            Conditions of Use Privacy Notice Your Ads Privacy Choices
            <div className="foot-copy">
            © 2021-2023, Inc. or its affiliates
            </div>
            </div>
        </div>
    )
}
export default Footer;